<template>
    <Header></Header>
    <Left></Left>
    <section class="container" id="pdfArea" :class="{ pdfMode: isPdfMode }">
        <div>
            <div class="area_title">
                <p>개별지원통합카드</p>

                <div class="area_button">
                    <button type="button" @click="downloadPdf">
                        <img src="img/print.png" />
                        <span>PDF 출력</span>
                    </button>

                    <button type="button" @click="downloadExcel">
                        <img src="img/excel.png" />
                        <span>Excel 다운</span>
                    </button>

                    <button type="button" @click="router.push({ name: 'clientDetail', params: { id: state.idx } })">
                        <span>기초기록으로 연계</span>
                    </button>
                </div>
            </div>

            <div class="area_body" style="margin-bottom: 10px">
                <div class="area_section flex ac">
                    <div class="flex ac noPrint">
                        <label>기간설정</label>
                        <div class="flex ac">
                            <div class="datepicker"><input type="date" id="startDate" v-model="state.startDate" @change="changeStartDate" /></div>
                            <span>~</span>
                            <div class="datepicker"><input type="date" id="endDate" v-model="state.endDate" @change="changeEndDate" /></div>
                        </div>
                    </div>
                    <table class="print_table onlyPrint">
                        <tbody>
                            <tr class="">
                                <th class="second_th"><b>연번</b></th>
                                <td class="left"><p v-text="state.data.client.number"></p></td>
                            </tr>
                            <tr class="">
                                <th class="second_th"><b>작성일</b></th>
                                <td class="left"><p v-text=""></p></td>
                            </tr>
                            <tr class="">
                                <th class="second_th"><b>작성자</b></th>
                                <td class="left">
                                    <div class="flex jc">
                                        <p v-text=""></p>
                                        <span class="onlyPrint">(서명)</span>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div>
                <table class="print_table">
                    <tbody>
                        <tr class="noPrint">
                            <th rowspan="3" class="first_th"><b>기초자료</b></th>
                            <th class="second_th"><b>연번</b></th>
                            <td colspan="7" class="left"><p v-text="state.data.client.number"></p></td>
                        </tr>
                        <tr class="noPrint">
                            <th class="second_th"><b>작성일</b></th>
                            <td colspan="7" class="left"><p v-text=""></p></td>
                        </tr>
                        <tr class="noPrint">
                            <th class="second_th"><b>작성자</b></th>
                            <td colspan="7" class="left"><p v-text=""></p></td>
                        </tr>

                        <tr>
                            <th rowspan="4" class="first_th">인적사항</th>
                            <th class="second_th gray_th">성명</th>
                            <td colspan="7" class="left"><p v-text="state.data.client.name"></p></td>
                        </tr>
                        <tr>
                            <th class="second_th gray_th">주민등록번호</th>
                            <td colspan="7" class="left"><p v-text="CommonUtils.convertJumin(state.data.client.clientDetailVO.jumin)"></p></td>
                        </tr>
                        <tr>
                            <th class="second_th gray_th">연락처</th>
                            <td colspan="7" class="left"><p v-text="CommonUtils.convertPhoneNum(state.data.client.clientDetailVO.phone)"></p></td>
                        </tr>
                        <tr>
                            <th class="second_th gray_th">주소</th>
                            <td colspan="7" class="left"><p v-text="state.data.client.clientDetailVO.address"></p></td>
                        </tr>

                        <template v-for="(group, gIdx) in medicalChunks" :key="gIdx">
                            <tr>
                                <th v-if="gIdx == 0" :rowspan="medicalChunks.length * 5">의료지원</th>

                                <th class="second_th gray_th">번호</th>
                                <template v-for="(item, idx) in group" :key="idx">
                                    <td>{{ idx + 1 + gIdx * 6 }}</td>
                                </template>
                                <td>비고</td>
                            </tr>
                            <tr>
                                <th class="second_th gray_th">일시</th>
                                <template v-for="(item, idx) in group" :key="idx">
                                    <td>
                                        <router-link
                                            v-if="item.coIdx"
                                            :to="{ name: 'counselDetail', params: { id: item.clIdx, idx: item.coIdx } }"
                                            target="_blank"
                                        >
                                            {{ CommonUtils.dateFormatYYYYMMDD(item.date, ".") }}
                                        </router-link>
                                    </td>
                                </template>
                                <td></td>
                            </tr>
                            <tr>
                                <th class="second_th gray_th">금액(원)</th>
                                <template v-for="(item, idx) in group" :key="idx">
                                    <td>
                                        <router-link
                                            v-if="item.coIdx"
                                            :to="{ name: 'counselDetail', params: { id: item.clIdx, idx: item.coIdx } }"
                                            target="_blank"
                                        >
                                            {{ item.price ? CommonUtils.numberFormat(item.price + "".replaceAll(",", "")) : "" }}
                                        </router-link>
                                    </td>
                                </template>
                                <td></td>
                            </tr>
                            <tr>
                                <th class="second_th gray_th">진료과목</th>
                                <template v-for="(item, idx) in group" :key="idx">
                                    <td>
                                        <router-link
                                            v-if="item.coIdx"
                                            :to="{ name: 'counselDetail', params: { id: item.clIdx, idx: item.coIdx } }"
                                            target="_blank"
                                        >
                                            {{ item.method && item.method.indexOf("기타") > -1 ? "기타" : item.method }}
                                        </router-link>
                                    </td>
                                </template>
                                <td></td>
                            </tr>
                            <tr>
                                <th class="second_th gray_th">지원시설</th>
                                <template v-for="(item, idx) in group" :key="idx">
                                    <td>
                                        <router-link
                                            v-if="item.coIdx"
                                            :to="{ name: 'counselDetail', params: { id: item.clIdx, idx: item.coIdx } }"
                                            target="_blank"
                                        >
                                            다시함께센터
                                        </router-link>
                                    </td>
                                </template>
                                <td></td>
                            </tr>
                        </template>
                        <template v-for="(group, gIdx) in lawChunks" :key="gIdx">
                            <tr>
                                <th v-if="gIdx == 0" :rowspan="lawChunks.length * 5">법률지원</th>

                                <th class="second_th gray_th">번호</th>
                                <template v-for="(item, idx) in group" :key="idx">
                                    <td>{{ idx + 1 + gIdx * 6 }}</td>
                                </template>
                                <td>비고</td>
                            </tr>
                            <tr>
                                <th class="second_th gray_th">일시</th>
                                <template v-for="(item, idx) in group" :key="idx">
                                    <td>
                                        <router-link
                                            v-if="item.coIdx"
                                            :to="{ name: 'counselDetail', params: { id: item.clIdx, idx: item.coIdx } }"
                                            target="_blank"
                                        >
                                            {{ CommonUtils.dateFormatYYYYMMDD(item.date, ".") }}
                                        </router-link>
                                    </td>
                                </template>
                                <td></td>
                            </tr>
                            <tr>
                                <th class="second_th gray_th">금액(원)</th>
                                <template v-for="(item, idx) in group" :key="idx">
                                    <td>
                                        <router-link
                                            v-if="item.coIdx"
                                            :to="{ name: 'counselDetail', params: { id: item.clIdx, idx: item.coIdx } }"
                                            target="_blank"
                                        >
                                            {{ item.price ? CommonUtils.numberFormat(item.price + "".replaceAll(",", "")) : "" }}
                                        </router-link>
                                    </td>
                                </template>
                                <td></td>
                            </tr>
                            <tr>
                                <th class="second_th gray_th">진료과목</th>
                                <template v-for="(item, idx) in group" :key="idx">
                                    <td>
                                        <router-link
                                            v-if="item.coIdx"
                                            :to="{ name: 'counselDetail', params: { id: item.clIdx, idx: item.coIdx } }"
                                            target="_blank"
                                        >
                                            {{ item.method && item.method.indexOf("기타") > -1 ? "기타" : item.method }}
                                        </router-link>
                                    </td>
                                </template>
                                <td></td>
                            </tr>
                            <tr>
                                <th class="second_th gray_th">지원시설</th>
                                <template v-for="(item, idx) in group" :key="idx">
                                    <td>
                                        <router-link
                                            v-if="item.coIdx"
                                            :to="{ name: 'counselDetail', params: { id: item.clIdx, idx: item.coIdx } }"
                                            target="_blank"
                                        >
                                            다시함께센터
                                        </router-link>
                                    </td>
                                </template>
                                <td></td>
                            </tr>
                        </template>
                        <template v-for="(group, gIdx) in vocationalTrainingChunks" :key="gIdx">
                            <tr>
                                <th v-if="gIdx == 0" :rowspan="vocationalTrainingChunks.length * 5">직업훈련지원</th>

                                <th class="second_th gray_th">번호</th>
                                <template v-for="(item, idx) in group" :key="idx">
                                    <td>{{ idx + 1 + gIdx * 6 }}</td>
                                </template>
                                <td>비고</td>
                            </tr>
                            <tr>
                                <th class="second_th gray_th">일시</th>
                                <template v-for="(item, idx) in group" :key="idx">
                                    <td>
                                        <router-link
                                            v-if="item.coIdx"
                                            :to="{ name: 'counselDetail', params: { id: item.clIdx, idx: item.coIdx } }"
                                            target="_blank"
                                        >
                                            {{ CommonUtils.dateFormatYYYYMMDD(item.date, ".") }}
                                        </router-link>
                                    </td>
                                </template>
                                <td></td>
                            </tr>
                            <tr>
                                <th class="second_th gray_th">금액(원)</th>
                                <template v-for="(item, idx) in group" :key="idx">
                                    <td>
                                        <router-link
                                            v-if="item.coIdx"
                                            :to="{ name: 'counselDetail', params: { id: item.clIdx, idx: item.coIdx } }"
                                            target="_blank"
                                        >
                                            {{ item.price ? CommonUtils.numberFormat(item.price + "".replaceAll(",", "")) : "" }}
                                        </router-link>
                                    </td>
                                </template>
                                <td></td>
                            </tr>
                            <tr>
                                <th class="second_th gray_th">진료과목</th>
                                <template v-for="(item, idx) in group" :key="idx">
                                    <td>
                                        <router-link
                                            v-if="item.coIdx"
                                            :to="{ name: 'counselDetail', params: { id: item.clIdx, idx: item.coIdx } }"
                                            target="_blank"
                                        >
                                            {{ item.method && item.method.indexOf("기타") > -1 ? "기타" : item.method }}
                                        </router-link>
                                    </td>
                                </template>
                                <td></td>
                            </tr>
                            <tr>
                                <th class="second_th gray_th">지원시설</th>
                                <template v-for="(item, idx) in group" :key="idx">
                                    <td>
                                        <router-link
                                            v-if="item.coIdx"
                                            :to="{ name: 'counselDetail', params: { id: item.clIdx, idx: item.coIdx } }"
                                            target="_blank"
                                        >
                                            다시함께센터
                                        </router-link>
                                    </td>
                                </template>
                                <td></td>
                            </tr>
                        </template>
                        <template v-for="(group, gIdx) in mindChunks" :key="gIdx">
                            <tr>
                                <th v-if="gIdx == 0" :rowspan="mindChunks.length * 5">심리지원</th>

                                <th class="second_th gray_th">번호</th>
                                <template v-for="(item, idx) in group" :key="idx">
                                    <td>{{ idx + 1 + gIdx * 6 }}</td>
                                </template>
                                <td>비고</td>
                            </tr>
                            <tr>
                                <th class="second_th gray_th">일시</th>
                                <template v-for="(item, idx) in group" :key="idx">
                                    <td>
                                        <router-link
                                            v-if="item.coIdx"
                                            :to="{ name: 'counselDetail', params: { id: item.clIdx, idx: item.coIdx } }"
                                            target="_blank"
                                        >
                                            {{ CommonUtils.dateFormatYYYYMMDD(item.date, ".") }}
                                        </router-link>
                                    </td>
                                </template>
                                <td></td>
                            </tr>
                            <tr>
                                <th class="second_th gray_th">금액(원)</th>
                                <template v-for="(item, idx) in group" :key="idx">
                                    <td>
                                        <router-link
                                            v-if="item.coIdx"
                                            :to="{ name: 'counselDetail', params: { id: item.clIdx, idx: item.coIdx } }"
                                            target="_blank"
                                        >
                                            {{ item.price ? CommonUtils.numberFormat(item.price + "".replaceAll(",", "")) : "" }}
                                        </router-link>
                                    </td>
                                </template>
                                <td></td>
                            </tr>
                            <tr>
                                <th class="second_th gray_th">진료과목</th>
                                <template v-for="(item, idx) in group" :key="idx">
                                    <td>
                                        <router-link
                                            v-if="item.coIdx"
                                            :to="{ name: 'counselDetail', params: { id: item.clIdx, idx: item.coIdx } }"
                                            target="_blank"
                                        >
                                            {{ item.method && item.method.indexOf("기타") > -1 ? "기타" : item.method }}
                                        </router-link>
                                    </td>
                                </template>
                                <td></td>
                            </tr>
                            <tr>
                                <th class="second_th gray_th">지원시설</th>
                                <template v-for="(item, idx) in group" :key="idx">
                                    <td>
                                        <router-link
                                            v-if="item.coIdx"
                                            :to="{ name: 'counselDetail', params: { id: item.clIdx, idx: item.coIdx } }"
                                            target="_blank"
                                        >
                                            다시함께센터
                                        </router-link>
                                    </td>
                                </template>
                                <td></td>
                            </tr>
                        </template>
                        <template v-for="(group, gIdx) in suppotChunks" :key="gIdx">
                            <tr>
                                <th v-if="gIdx == 0" :rowspan="suppotChunks.length * 5">구조지원비증액</th>

                                <th class="second_th gray_th">번호</th>
                                <template v-for="(item, idx) in group" :key="idx">
                                    <td>{{ idx + 1 + gIdx * 6 }}</td>
                                </template>
                                <td>비고</td>
                            </tr>
                            <tr>
                                <th class="second_th gray_th">일시</th>
                                <template v-for="(item, idx) in group" :key="idx">
                                    <td>
                                        <router-link
                                            v-if="item.coIdx"
                                            :to="{ name: 'counselDetail', params: { id: item.clIdx, idx: item.coIdx } }"
                                            target="_blank"
                                        >
                                            {{ CommonUtils.dateFormatYYYYMMDD(item.date, ".") }}
                                        </router-link>
                                    </td>
                                </template>
                                <td></td>
                            </tr>
                            <tr>
                                <th class="second_th gray_th">금액(원)</th>
                                <template v-for="(item, idx) in group" :key="idx">
                                    <td>
                                        <router-link
                                            v-if="item.coIdx"
                                            :to="{ name: 'counselDetail', params: { id: item.clIdx, idx: item.coIdx } }"
                                            target="_blank"
                                        >
                                            {{ item.price ? CommonUtils.numberFormat(item.price + "".replaceAll(",", "")) : "" }}
                                        </router-link>
                                    </td>
                                </template>
                                <td></td>
                            </tr>
                            <tr>
                                <th class="second_th gray_th">진료과목</th>
                                <template v-for="(item, idx) in group" :key="idx">
                                    <td>
                                        <router-link
                                            v-if="item.coIdx"
                                            :to="{ name: 'counselDetail', params: { id: item.clIdx, idx: item.coIdx } }"
                                            target="_blank"
                                        >
                                            {{ item.method && item.method.indexOf("기타") > -1 ? "기타" : item.method }}
                                        </router-link>
                                    </td>
                                </template>
                                <td></td>
                            </tr>
                            <tr>
                                <th class="second_th gray_th">지원시설</th>
                                <template v-for="(item, idx) in group" :key="idx">
                                    <td>
                                        <!-- <router-link
                                        v-if="item.coIdx"
                                        :to="{ name: 'counselDetail', params: { id: item.clIdx, idx: item.coIdx } }"
                                        target="_blank"
                                    >
                                        다시함께센터
                                    </router-link> -->
                                    </td>
                                </template>
                                <td></td>
                            </tr>
                        </template>
                        <tr>
                            <th rowspan="10" class="first_th"><b>특이사항</b></th>
                            <th class="second_th">의료지원 합계</th>
                            <td colspan="7" class="left">{{ CommonUtils.numberFormat(state.summary.medical) }}</td>
                        </tr>
                        <tr>
                            <th class="second_th">법률지원 합계</th>
                            <td colspan="7" class="left">{{ CommonUtils.numberFormat(state.summary.law) }}</td>
                        </tr>
                        <tr>
                            <th class="second_th">직업훈련 합계</th>
                            <td colspan="7" class="left">{{ CommonUtils.numberFormat(state.summary.vocationalTraining) }}</td>
                        </tr>
                        <tr>
                            <th class="second_th">심리지원 합계</th>
                            <td colspan="7" class="left">{{ CommonUtils.numberFormat(state.summary.mind) }}</td>
                        </tr>
                        <tr>
                            <th class="second_th">구조지원비 증액 합계</th>
                            <td colspan="7" class="left">{{ CommonUtils.numberFormat(state.summary.support + 10000000) }}원</td>
                        </tr>
                        <tr>
                            <th class="second_th">이전지원 총합계</th>
                            <td colspan="7" class="left">
                                <span v-if="state.data.etc.length > 0 && state.data.etc[0].newPrevInstitution" style="color: red">
                                    {{ CommonUtils.numberFormat(state.data.etc[0].newPrevSupportingExpensePrice) }} 원 (이전의료지원 비용:
                                    {{ CommonUtils.numberFormat(state.data.etc[0].newPrevMedicalPrice) }}원, 이전법률지원 비용:{{
                                        CommonUtils.numberFormat(state.data.etc[0].newPrevLawPrice)
                                    }}원, 이전직업훈련 비용:{{ CommonUtils.numberFormat(state.data.etc[0].newPrevJobTrainingPrice) }}원, 이전 미파악
                                    총비용:{{ CommonUtils.numberFormat(state.data.etc[0].newPrevNotGraspPrice) }}, 이전기관명 :
                                    {{ state.data.etc[0].newPrevInstitution }})
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <th class="second_th">총합계</th>
                            <td colspan="7" class="left">
                                {{
                                    CommonUtils.numberFormat(
                                        state.summary.medical + state.summary.law + state.summary.vocationalTraining + state.summary.mind,
                                    )
                                }}원
                            </td>
                        </tr>
                        <tr>
                            <th class="second_th">잔액</th>
                            <td colspan="7" class="left">
                                {{
                                    CommonUtils.numberFormat(
                                        state.summary.support +
                                            10000000 -
                                            (state.data.etc.length > 0 ? state.data.etc[0].newPrevSupportingExpensePrice : 0) -
                                            (state.summary.medical + state.summary.law + state.summary.vocationalTraining + state.summary.mind),
                                    )
                                }}원
                            </td>
                        </tr>
                        <tr>
                            <th class="second_th">구조지원비 사용 내역</th>
                            <td colspan="7" class="left">
                                <p v-for="(item, key) in state.data.etcDetail" style="height: auto; width: 100%; margin-bottom: 5px">
                                    [{{ item.date }}] {{ item.newCounselorDesc }}
                                </p>
                            </td>
                        </tr>
                        <tr class="noPrint">
                            <th class="second_th">기타</th>
                            <td colspan="7" class="left">
                                <div class="textarea_wrap">
                                    <textarea v-model="state.data.client.commentForSupportCard"></textarea>
                                </div>

                                <button type="button" @click="saveComment">
                                    <span>저장</span>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </section>

    <Spinner :is-full-page="true" v-if="state.isLoading"></Spinner>
    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        @close="closeModal"
        @callback="callBackModal"
    ></ModalDefault>
</template>
<script lang="ts" config>
    import {
        reactive,
        watch,
        apiService,
        onMounted,
        router,
        Header,
        Left,
        ModalDefault,
        types,
        getMessageByCode,
        CommonUtils,
        useRoute,
        computed,
        ref,
        Spinner,
    } from "@/BaseComponent";

    export default {
        props: {},
        components: { Header, Left, ModalDefault, Spinner },
        setup() {
            const route = useRoute();

            const state = reactive({
                startDate: "" as string,
                endDate: "" as string,

                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalTitle: "alert" as string,
                modalContent: "" as string,

                idx: 0 as number,

                data: {
                    client: {
                        clientDetailVO: {
                            jumin: "" as string,
                            phone: "" as string,
                            address: "" as string,
                        },
                        commentForSupportCard: "" as string,
                    } as types.client.ClientVOForApi,
                    medical: [] as Array<any>,
                    law: [] as Array<any>,
                    vocationalTraining: [] as Array<any>,
                    mind: [] as Array<any>,
                    support: [] as Array<any>,
                    etc: [] as Array<any>,
                    etcDetail: [] as Array<any>,
                } as any,

                summary: {
                    medical: 0 as number,
                    law: 0 as number,
                    vocationalTraining: 0 as number,
                    mind: 0 as number,
                    support: 0 as number,
                },

                isLoading: false,
            });

            interface Item {
                date: string;
                price: number;
                method: string;
                clIdx: number;
                coIdx: number;
            }

            const medicalChunks = computed<Item[][]>(() => {
                const chunkSize = 6;
                const arr = state.data.medical;
                const chunks: Item[][] = [];

                for (let r = 0; r < (arr.length > chunkSize ? Math.ceil(arr.length / chunkSize) : 1); r++) {
                    const start = r * chunkSize;
                    const rowItems = arr.slice(start, start + chunkSize);
                    // col이 6보다 적으면 빈 객체 채움

                    while (rowItems.length < chunkSize) rowItems.push({});

                    chunks.push(rowItems);
                }
                return chunks;
            });

            const lawChunks = computed<Item[][]>(() => {
                const chunkSize = 6;
                const arr = state.data.law;
                const chunks: Item[][] = [];

                for (let r = 0; r < (arr.length > chunkSize ? Math.ceil(arr.length / chunkSize) : 1); r++) {
                    const start = r * chunkSize;
                    const rowItems = arr.slice(start, start + chunkSize);

                    // col이 6보다 적으면 빈 객체 채움
                    while (rowItems.length < chunkSize) rowItems.push({});

                    chunks.push(rowItems);
                }
                return chunks;
            });

            const vocationalTrainingChunks = computed<Item[][]>(() => {
                const chunkSize = 6;
                const arr = state.data.vocationalTraining; // 기존 데이터 복사
                const chunks: Item[][] = [];
                // 총 row 수 만큼 반복

                for (let r = 0; r < (arr.length > chunkSize ? Math.ceil(arr.length / chunkSize) : 1); r++) {
                    const start = r * chunkSize;
                    const rowItems = arr.slice(start, start + chunkSize);

                    // col이 6보다 적으면 빈 객체 채움
                    while (rowItems.length < chunkSize) rowItems.push({});

                    chunks.push(rowItems);
                }

                return chunks;
            });

            const mindChunks = computed<Item[][]>(() => {
                const chunkSize = 6;
                const arr = state.data.mind;
                const chunks: Item[][] = [];

                for (let r = 0; r < (arr.length > chunkSize ? Math.ceil(arr.length / chunkSize) : 1); r++) {
                    const start = r * chunkSize;
                    const rowItems = arr.slice(start, start + chunkSize);

                    // col이 6보다 적으면 빈 객체 채움
                    while (rowItems.length < chunkSize) rowItems.push({});

                    chunks.push(rowItems);
                }

                return chunks;
            });

            const suppotChunks = computed<Item[][]>(() => {
                const chunkSize = 6;
                const arr = state.data.support;
                const chunks: Item[][] = [];

                for (let r = 0; r < (arr.length > chunkSize ? Math.ceil(arr.length / chunkSize) : 1); r++) {
                    const start = r * chunkSize;
                    const rowItems = arr.slice(start, start + chunkSize);

                    // col이 6보다 적으면 빈 객체 채움
                    while (rowItems.length < chunkSize) rowItems.push({});

                    chunks.push(rowItems);
                }

                return chunks;
            });

            onMounted(async () => {
                if (route.params.id) {
                    state.idx = Number(route.params.id);

                    getData();
                }
            });

            watch(
                () => route.params.id,
                () => {
                    if (route.params.id) {
                        state.idx = Number(route.params.id);

                        getData();
                    }
                },
            );

            watch(
                () => [state.startDate, state.endDate],
                () => {
                    getData();
                },
            );

            const getData = async () => {
                state.isLoading = true;
                const param: types.client.ReqClientSupportCard = {
                    startDate: state.startDate,
                    endDate: state.endDate,
                };
                const res = await apiService.client.supportCard(state.idx, param);

                if (res.returnCode === 0) {
                    state.data = res;

                    if (state.data.medical)
                        state.summary.medical = state.data.medical.reduce(
                            (sum: any, item: any) => sum + Number(item.price.replaceAll(",", "") || 0),
                            0,
                        );
                    else state.summary.medical = 0;

                    if (state.data.law)
                        state.summary.law = state.data.law.reduce((sum: any, item: any) => sum + Number(item.price.replaceAll(",", "") || 0), 0);
                    else state.summary.law = 0;

                    if (state.data.vocationalTraining)
                        state.summary.vocationalTraining = state.data.vocationalTraining.reduce(
                            (sum: any, item: any) => sum + Number(item.price.replaceAll(",", "") || 0),
                            0,
                        );
                    else state.summary.vocationalTraining = 0;

                    if (state.data.mind)
                        state.summary.mind = state.data.mind.reduce((sum: any, item: any) => sum + Number(item.price.replaceAll(",", "") || 0), 0);
                    else state.summary.mind = 0;

                    if (state.data.support)
                        state.summary.support = state.data.support.reduce(
                            (sum: any, item: any) => sum + Number(item.price.replaceAll(",", "") || 0),
                            0,
                        );
                    else state.summary.support = 0;
                } else {
                    state.data = null;
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
                state.isLoading = false;
            };

            const closeModal = () => {
                state.isShowModal = false;
            };

            const callBackModal = async (param: any) => {};

            const isPdfMode = ref(false);

            const downloadPdf = async () => {
                state.isLoading = true;
                isPdfMode.value = true; // PDF 스타일 적용

                // const el = document.getElementById("pdfArea");

                window.print();

                // await nextTick(); // DOM 업데이트 반영 후 캡처
                // await CommonUtils.downloadPdf();

                isPdfMode.value = false; // 다시 원상복귀

                state.isLoading = false;
                // const param: types.client.ReqClientSupportCard = {
                //     startDate: state.startDate,
                //     endDate: state.endDate,
                // };
                // const res = await apiService.client.exportPdfForSupportCard(state.idx, param);
                // if (res) {
                //     if (res.returnCode) {
                //         console.error(res.returnCode);
                //         console.error(getMessageByCode(res.returnCode));
                //     } else {
                //         const blob = new Blob([res.data], {
                //             type: "application/pdf",
                //         });
                //         const disposition = res.headers["content-disposition"];
                //         let fileName = "download.pdf";
                //         if (disposition) {
                //             const match = disposition.match(/filename="?(.+)"?/);
                //             if (match && match[1]) {
                //                 fileName = decodeURIComponent(match[1]);
                //             }
                //         }
                //         const a = document.createElement("a");
                //         const url = window.URL.createObjectURL(blob);
                //         a.href = url;
                //         a.download = fileName;
                //         document.body.appendChild(a);
                //         a.click();
                //         document.body.removeChild(a);
                //         URL.revokeObjectURL(url);
                //     }
                // } else {
                //     state.modalTab = -1;
                //     state.modalTitle = "알림";
                //     state.modalContent = getMessageByCode(res.returnCode);
                //     state.isShowModal = true;
                // }
            };

            const downloadExcel = async () => {
                state.isLoading = true;
                const param: types.client.ReqClientSupportCard = {
                    startDate: state.startDate,
                    endDate: state.endDate,
                };
                const res = await apiService.client.exportExcelForSupportCard(state.idx, param);
                if (res && res.data) {
                    const blob = new Blob([res.data], {
                        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                    });
                    const disposition = res.headers["content-disposition"];
                    let fileName = "download.xlsx";
                    if (disposition) {
                        const match = disposition.match(/filename="?(.+)"?/);
                        if (match && match[1]) {
                            fileName = decodeURIComponent(match[1]);
                        }
                    }
                    const a = document.createElement("a");
                    const url = window.URL.createObjectURL(blob);
                    a.href = url;
                    a.download = fileName;
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                    URL.revokeObjectURL(url);
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
                state.isLoading = false;
            };
            const changeStartDate = () => {
                if (!CommonUtils.checkDateRange(state.startDate, state.endDate)) {
                    state.endDate = state.startDate;
                }
            };
            const changeEndDate = () => {
                if (!CommonUtils.checkDateRange(state.startDate, state.endDate)) {
                    state.endDate = state.startDate;
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "작성일 범위가 잘못 선택되었습니다.";
                    state.isShowModal = true;
                }
            };

            const saveComment = async () => {
                const param: types.client.ReqClientSupportCardForModify = {
                    comment: state.data.client.commentForSupportCard,
                };
                const res = await apiService.client.modifyForSupportCard(state.idx, param);
                if (res.returnCode === 0) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "저장 되었습니다.";
                    state.isShowModal = true;
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            return {
                state,
                router,

                CommonUtils,
                closeModal,
                callBackModal,

                medicalChunks,
                lawChunks,
                vocationalTrainingChunks,
                mindChunks,
                suppotChunks,
                window,
                downloadPdf,
                downloadExcel,
                isPdfMode,

                changeStartDate,
                changeEndDate,
                saveComment,
            };
        },
    };
</script>
<style scoped>
    .area_col > div.area_col_head {
        height: 40px;
        text-align: center;
    }

    .area_label > .area_col > div.area_col_head > label {
        width: 100%;
    }

    .area_array .area_col > div.area_col_head {
        padding-left: 0 !important;
    }

    .area_array .area_col > div.area_col_head {
        width: 160px;
    }

    .area_array div.area_col_row:not(.area_label) .area_col > div.area_col_head {
        width: 100%;
    }

    .area_array {
        /* flex: none !important; */
        width: auto;
    }

    .container div.area_body div.area_section div.area_row div.area_col_body > * {
        margin: 0;
    }

    .container div.area_body div.area_section div.area_row div.area_col_head {
        min-width: 160px;
        min-height: 35px;

        justify-content: center;
        text-align: center;
    }
    .container div.area_body div.area_section div.area_row > div.area_col_head {
        height: auto;
    }
    .pdfMode {
        width: 150mm; /* ★ PDF때만 좁게 */
        margin: 0 auto;
        background: white;
    }

    .onlyPrint {
        display: none;
    }
    .datepicker input {
        height: 30px;
    }
    .area_section div.area_row div.area_col_row > div.area_col {
        align-items: stretch;
    }
    .area_section div.area_row div.area_col_row.area_label {
        max-width: 160px;
    }
    .area_section div.area_row div.area_col_row.area_label > .area_col > .area_col_head {
        background: #f5f5f5;
    }
    .area_section div.area_row div.area_col_row.area_label label {
        color: #6d6d6d;
    }
    .area_section div.area_row div.area_col_row.area_total_row div.area_col_head {
        background: #f5f5f5;
        padding-left: 0;
    }
    .area_section div.area_row div.area_col_row.area_total_row div.area_col_head label {
        color: #6d6d6d;
    }
    .area_section .area_form_body > .area_row > .area_col_head {
        padding-left: 0;
    }
    .area_card_body {
        border-left: 1px solid #d9d9d9;
        border-right: 1px solid #d9d9d9;
    }
    .area_section div.area_row .area_array > .area_col .area_col_row:last-child .area_col_head {
        border-right: 0 !important;
    }
    .area_form div.area_form_body div.area_row > .area_col_row > div.area_col > div.area_col_head {
        padding-left: 0;
    }

    .textarea_wrap textarea {
        width: 100%;
    }
</style>
